import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IBOMSetupListDetailResponse, IBOMSetupListDetailResponseData } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useBOMSetupDetailAPI = () => {
  const [bomDetail, setBomDetail] = useState<any>({
    vms_category_id: "",
    vms_category_name: "",
    vms_subcategory_id: "",
    vms_subcategory_name: "",
    general_details: {
      service_details: {
        bom_name: "",
      },
      product_component: [],
    },
    clinic_mapping: [],
    status: false,
    bom_id: "",
  });
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (bom_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .get(`${INVENTORY_MODULE?.BOM_SETUP_DETAIL_API?.baseURL}${bom_id}/`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IBOMSetupListDetailResponse>) => {
            if (res.data.status) {
              setBomDetail(res.data.data);
              return { status: true, message: null };
            } else {
              setBomDetail(null);
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            setBomDetail(null);
            sendCurl(e.config["curlCommand"]);
            return { status: false, message: null };
          });
        return response;
      } catch (error) {
        setBomDetail(null);
        if (axios.isAxiosError(error)) {
          captureError(error);
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );

  return { execute, bomDetail };
};
